import React from 'react';

import EasyPayOption from '../easy-pay-option/easy-pay-option';
import { FLEET_COAST_CARD_NAME } from './coast-card-banner-constants';

import { GET_CMS_COAST_CARD_DETAILS } from './graphql/coast-card-queries';

import { useQuery } from '../../shared/hooks/hooks';

function CoastCardBanner() {
  const coastCardName = window.isDT
    ? FLEET_COAST_CARD_NAME?.DT
    : FLEET_COAST_CARD_NAME?.AT;

  const { data, error } = useQuery(GET_CMS_COAST_CARD_DETAILS, {
    variables: {
      id: 'buy-tires'
    }
  });

  if (error) {
    <div data-testid="coast-card-banner" />;
  }

  const { cms } = data || {};
  const { page: cmsPage } = cms || {};
  const { contentSlots = [] } = cmsPage || {};

  const coastCard = contentSlots
    ?.find(slot => slot.name === 'financing-content')
    ?.cmsComponents?.find(comp => comp?.name === 'financing.credit-card')
    ?.sections?.find(section => section.name === coastCardName);

  function handleButtonClick() {
    window.open(coastCard?.link?.href, coastCard?.link?.target);
  }

  return (
    <div data-testid="coast-card-banner">
      {coastCard && (
        <EasyPayOption
          imageAlt={coastCard?.image?.altText}
          imageUrl={coastCard?.image?.url}
          linkText={coastCard?.link?.text}
          message={coastCard?.info}
          onClick={handleButtonClick}
          title={coastCard?.heading}
        />
      )}
    </div>
  );
}

export default CoastCardBanner;
